(function ($, ko) {

    ko.bindingHandlers.chartContributionsCurYear = {
        init: function (element, valueAccessor) {
        },
        update: function (element, valueAccessor) {
            var account = ko.unwrap(valueAccessor());
            if (!account  || !account.AccountId) return;

            // Please don't remove for tests
            //account.YTDEmployer = 703.00;
            //account.YTDYour = 2373.24;

            //Visibility of series label - if values diff is too much
            var firstSerieLabelsVisible = account.hasOwnProperty('YTDEmployer') && Math.round(account.YTDEmployer / (account.YTDYour || 0.001)) < 50;
            var secondSerieLabelsVisible = account.hasOwnProperty('YTDYour') && Math.round(account.YTDYour / (account.YTDEmployer || 0.001)) < 50;

            // prepare jqxChart settings
            var extendSettings = {
                valueAxis: {
                    unitInterval: account.hasOwnProperty('YTDEmployer') ? Math.round((account.YTDYour + account.YTDEmployer) / 4) || 1 : 1,
                    labels: { step: 1, horizontalAlignment: 'right', formatSettings: { prefix: '$', decimalPlaces: 2 } },
                    tickMarks: { color: '#eee' },
                    gridLines: { color: '#eee' }
                },
                seriesGroups: [{
                    series: [{
                        dataField: 'YTDYour',
                        displayText: $.cdh.languageConstant.getConstant('AccountDetail.lblYourDeposits'),
                        opacity: '1',
                        lineWidth: 0,
                        formatSettings: { prefix: '$', decimalPlaces: 2 },
                        //labels: { visible: firstSerieLabelsVisible, offset: { x: 0, y: 0 }, verticalAlignment: 'bottom', class: 'account-contribution-text mod_contributions' },
                        toolTipFormatFunction: function (value, itemIndex, serieIndex, groupIndex) {
                            return $.cdh.languageConstant.getConstant('AccountDetail.lblYourDeposits')+ ': $' + value;
                        }
                    },
                    {
                        dataField: 'YTDEmployer',
                        displayText: $.cdh.languageConstant.getConstant('AccountDetail.lblEmployerDeposits'),
                        opacity: '1',
                        lineWidth: 0,
                        formatSettings: { prefix: '$', decimalPlaces: 2 },
                        //labels: { visible: secondSerieLabelsVisible, offset: { x: 0, y: 0 }, verticalAlignment: 'top', class: 'account-contribution-text mod_contributions' },
                        toolTipFormatFunction: function (value, itemIndex, serieIndex, groupIndex) {
                            return $.cdh.languageConstant.getConstant('AccountDetail.lblEmployerDeposits') +': $' + value;
                        }
                    }]
                }]
            };

            //stacked column chart settings
            var chartData = {
                element: element,
                colorScheme: 'contributions-year',
                dataArr: [account],
                extendSettings: extendSettings
            };

            $(element).on('refreshEnd', function () {
                setTimeout(function () {
                    $.cdh.helper.buildContributionChartLabels(element, chartData);
                }, 1000);
            });

            //create the chart
            $.cdh.charts.bindStackedColumnChart(chartData);
        }
    };

    ko.bindingHandlers.chartContributionsPriorYear = {
        init: function (element, valueAccessor) {
        },
        update: function (element, valueAccessor) {
            var account = ko.unwrap(valueAccessor());
            if (!account || !account.AccountId) return;

            //Visibility of series label - if values diff is too much
            var firstSerieLabelsVisible = account.hasOwnProperty('PyEmployer') && Math.round(account.PyEmployer / (account.PyYour || 0.001)) < 50;
            var secondSerieLabelsVisible = account.hasOwnProperty('PyYour') && Math.round(account.PyYour / (account.PyEmployer || 0.001)) < 50;
            // prepare jqxChart settings
            var extendSettings = {
                valueAxis: {
                    unitInterval: account.hasOwnProperty('PyEmployer') ? Math.round((account.PyYour + account.PyEmployer) / 4) || 1 : 1,
                    labels: { step: 1, horizontalAlignment: 'right', formatSettings: { prefix: '$', decimalPlaces: 2 } },
                    tickMarks: { color: '#eee' },
                    gridLines: { color: '#eee' }
                },
                seriesGroups: [{
                    series: [{
                        dataField: 'PyYour',
                        displayText: $.cdh.languageConstant.getConstant('AccountDetail.lblYourPYDeposits'),
                        opacity: '1',
                        lineWidth: 0,
                        formatSettings: { prefix: '$', decimalPlaces: 2 },
                        //labels: { visible: firstSerieLabelsVisible, offset: { x: 0, y: 0 }, verticalAlignment: 'bottom', class: 'account-contribution-text mod_contributions' },
                        toolTipFormatFunction: function (value, itemIndex, serieIndex, groupIndex) {
                            return $.cdh.languageConstant.getConstant('AccountDetail.lblYourPYDeposits') +': $' + value;
                        }
                    },
                    {
                        dataField: 'PyEmployer',
                        displayText: $.cdh.languageConstant.getConstant('AccountDetail.lblEmployerPYDeposits'),
                        opacity: '1',
                        lineWidth: 0,
                        formatSettings: { prefix: '$', decimalPlaces: 2 },
                        //labels: { visible: secondSerieLabelsVisible, offset: { x: 0, y: 0 }, verticalAlignment: 'top', class: 'account-contribution-text mod_contributions' },
                        toolTipFormatFunction: function (value, itemIndex, serieIndex, groupIndex) {
                            return $.cdh.languageConstant.getConstant('AccountDetail.lblEmployerPYDeposits') +': $' + value;
                        }
                    }]
                }]
            };

            //stacked column chart settings
            var chartData = {
                element: element,
                colorScheme: 'contributions-year',
                dataArr: [account],
                extendSettings: extendSettings
            };

            $(element).on('refreshEnd', function () {
                setTimeout(function () {
                    $.cdh.helper.buildContributionChartLabels(element, chartData);
                }, 1000);
            });

            //create the chart
            $.cdh.charts.bindStackedColumnChart(chartData);
        }
    };

    ko.bindingHandlers.chartContributionsYearColorEmployer = {
        update: function (element, valueAccessor) {
            const color = $.cdh.brandData.ChartContributionsEmployerColor;
            $(element).css('background', color);
           /* $(element).css('opacity', 0.7);*/

            const pattern = $.cdh.helper.makeTagPattern(color, '0');
            const svg = $.cdh.helper.makePatternSvg(pattern);
            element.innerHTML += svg;
        }
    }

    ko.bindingHandlers.chartContributionsYearColorYour = {
        update: function (element, valueAccessor) {
            const color = $.cdh.brandData.ChartContributionsYourColor;
            $(element).css('background', color);
            /*$(element).css('opacity', 0.7);*/

            const pattern = $.cdh.helper.makeTagPattern(color, '1');
            const svg = $.cdh.helper.makePatternSvg(pattern);
            element.innerHTML += svg;
        }
    }

    ko.bindingHandlers.chartContributionsHSAvsIRS = {
        init: function (element, valueAccessor) {
        },
        update: function (element, valueAccessor) {
            var { account, isAllowedCatchUp } = ko.unwrap(valueAccessor());
            var isMobile = ($(window).width() < 426);
            if (account == undefined || account == null || account.AccountId == undefined) return;

            var stackedChartData = [
            {
                xAxisText: 'Allowed Single Limit',
                Position: !isMobile ? 0: 0.2,
                ReportableContributions: 0,
                RemainingAllowedContributions: 0,
                ExcessContributions: 0,
                ContributionLimit: account.IRSSingleLimit,
                CatchUpContributions: (isAllowedCatchUp ? account.CurrentYearCatchUpContribution : 0),
            },
            {
                xAxisText: 'vs. Single Limit',
                Position: !isMobile ? 0.4 : 0.6,
                ReportableContributions: Math.min(account.CurrentYearContributions, account.IRSSingleLimit + (isAllowedCatchUp ? account.CurrentYearCatchUpContribution : 0)),
                RemainingAllowedContributions: Math.max(account.IRSSingleLimit + (isAllowedCatchUp ? account.CurrentYearCatchUpContribution : 0) - account.CurrentYearContributions, 0),
                ExcessContributions: Math.max(account.CurrentYearContributions - account.IRSSingleLimit - (isAllowedCatchUp ? account.CurrentYearCatchUpContribution : 0), 0),
                ContributionLimit: 0,
                CatchUpContributions: 0
            },
            {
                xAxisText: 'Allowed Family Limit',
                Position: !isMobile ? 2 : 1.2,
                ReportableContributions: 0,
                RemainingAllowedContributions: 0,
                ExcessContributions: 0,
                ContributionLimit: account.IRSFamilyLimit,
                CatchUpContributions: (isAllowedCatchUp ? account.CurrentYearCatchUpContribution : 0),
            },
            {
                xAxisText: 'vs. Family Limit',
                Position: !isMobile ? 2.4 : 1.6,
                ReportableContributions: Math.min(account.CurrentYearContributions, account.IRSFamilyLimit + (isAllowedCatchUp ? account.CurrentYearCatchUpContribution : 0)),
                RemainingAllowedContributions: Math.max(account.IRSFamilyLimit + (isAllowedCatchUp ? account.CurrentYearCatchUpContribution : 0) - account.CurrentYearContributions, 0),
                ExcessContributions: Math.max(account.CurrentYearContributions - account.IRSFamilyLimit - (isAllowedCatchUp ? account.CurrentYearCatchUpContribution : 0), 0),
                ContributionLimit: 0,
                CatchUpContributions: 0
            }];

            function getTotalForStacked(itemIndex) {
                return stackedChartData[itemIndex].ReportableContributions + stackedChartData[itemIndex].RemainingAllowedContributions;
            }
            // prepare jqxChart settings
            var chartData = {
                element: element,
                colorScheme: 'contributions-hsa-vs-irs',
                columnsMaxWidth: !isMobile ? 45: 40,
                columnsMinWidth: !isMobile ? 45 : 35,
                xAxis: { dataField: 'Position', unitInterval: !isMobile ? 1 : 0.5, axisSize: 'auto', gridLines: { visible: false }, labels: {visible: false} },
                valueAxis: {
                    title: { text: '' },
                    unitInterval: 1000,
                    labels: { step: 1, horizontalAlignment: 'right', formatSettings: { prefix: '$', decimalPlaces: 2 } },
                    tickMarks: { color: '#BCBCBC' }
                },
                series: [{
                    dataField: 'ReportableContributions',
                    displayText: $.cdh.languageConstant.getConstant('profile.reportable-contributions'),
                    formatSettings: { prefix: '$', decimalPlaces: 2 },
                    labels: { visible: false },
                    toolTipFormatFunction: function (value, itemIndex, serieIndex, groupIndex) {
                        return $.cdh.languageConstant.getConstant('profile.reportable-contributions')+': $' + parseFloat(value).toFixed(2);
                    }
                },
                {
                    dataField: 'RemainingAllowedContributions',
                    displayText: $.cdh.languageConstant.getConstant('profile.remaining-allowed-contributions'),
                    formatSettings: { prefix: '$', decimalPlaces: 2 },
                    formatFunction: function (value, itemIndex, serieIndex, groupIndex) {
                        //var addText = itemIndex == 0 ? ' IRS Limit for Single' : ' IRS Limit for Family';
                        //return '$' + getTotalForStacked(itemIndex) + addText;
                        return 'IRS';
                    },
                    labels: { visible: true, offset: { x: 0, y: 0 }, verticalAlignment: 'top', class: 'account-contribution-text  text-black mod_irs' },
                    toolTipFormatFunction: function (value, itemIndex, serieIndex, groupIndex) {
                        return $.cdh.languageConstant.getConstant('profile.remaining-allowed-contributions') +': $' + parseFloat(value).toFixed(2);
                    }
                },
                {
                    dataField: 'ExcessContributions',
                    displayText: $.cdh.languageConstant.getConstant('profile.excess-contributions'),
                    formatSettings: { prefix: '$', decimalPlaces: 2 },
                    toolTipFormatFunction: function (value, itemIndex, serieIndex, groupIndex) {
                        return $.cdh.languageConstant.getConstant('profile.excess-contributions')+': $' + parseFloat(value).toFixed(2);
                }
                }, 
                {
                    dataField: 'ContributionLimit',
                    displayText: $.cdh.languageConstant.getConstant('profile.contribution-limit'),
                    formatSettings: { prefix: '$', decimalPlaces: 2 },
                    toolTipFormatFunction: function (value, itemIndex, serieIndex, groupIndex) {
                        return (value===account.IRSFamilyLimit ? $.cdh.languageConstant.getConstant('contributions.allowed-contribution-limit-for-family') : $.cdh.languageConstant.getConstant('contributions.allowed-contribution-limit-for-single')) + ': $' + parseFloat(value).toFixed(2);
                    }
                },
                {
                    dataField: 'CatchUpContributions',
                    displayText: 'Catch Up Contributions',
                    formatSettings: { prefix: '$', decimalPlaces: 2 },
                    toolTipFormatFunction: function (value, itemIndex, serieIndex, groupIndex) {
                        return $.cdh.languageConstant.getConstant('contributions.allowed-catchup-contribution')+': $' + parseFloat(value).toFixed(2);
                    }
                }],
                dataArr: stackedChartData
            };
            //Add label after refresh end
            $(element).on('refreshEnd', function () {
                setTimeout(function () {
                    var irsLimitModSingle = $('div.b-irs-limit.mod_single');
                    var irsLimitModFamily = $('div.b-irs-limit.mod_family');



                    // get rectangle index (this rect will used for calculating top coord)
                    var limitRectData = [
                        // single
                        {
                            rectIndex: 0,
                            amount: account.IRSSingleLimit
                        },
                        {
                            rectIndex: 5,
                            amount: Math.min(account.CurrentYearContributions, account.IRSSingleLimit + account.CurrentYearCatchUpContribution)
                        },
                        {
                            rectIndex: 10,
                            amount: account.IRSFamilyLimit
                        },
                        // family
                        {
                            rectIndex: 19,
                            amount: Math.min(account.CurrentYearContributions, account.IRSFamilyLimit + account.CurrentYearCatchUpContribution)
                        }
                    ];                
                    var $r = $(element).find('g:last');
                    var singleDataX = $r.find('rect:eq(' + limitRectData[0].rectIndex + ')').attr('x') + 30;
                    var familyDataX = $r.find('rect:eq(' + limitRectData[2].rectIndex + ')').attr('x') + 30;
                    irsLimitModSingle.css({
                        'top': '2px',
                        'left': singleDataX + 'px'
                    }).fadeIn('fast');
                    irsLimitModFamily.css({
                        'top': '2px',
                        'left': familyDataX + 'px'
                    }).fadeIn('fast');
                }, 700);

            });
            //create the chart
            $.cdh.charts.bindStackedColumnChart(chartData);
        }
    };

    ko.bindingHandlers.chartContributionsHSAvsIRSColorReportable = {
        update: function (element, valueAccessor) {
            const color = $.cdh.brandData.ChartContributionsVsIrsReportableColor;
            $(element).css('background', color);

            const pattern = $.cdh.helper.makeTagPattern(color, '0');
            const svg = $.cdh.helper.makePatternSvg(pattern);
            element.innerHTML += svg;
        }
    }

    ko.bindingHandlers.chartContributionsHSAvsIRSColorRemaining = {
        update: function (element, valueAccessor) {
            const color = $.cdh.brandData.ChartContributionsVsIrsRemainingColor;
            $(element).css('background', color);

            const pattern = $.cdh.helper.makeTagPattern(color, '1');
            const svg = $.cdh.helper.makePatternSvg(pattern);
            element.innerHTML += svg;
        }
    }

    ko.bindingHandlers.chartContributionsHSAvsIRSColorExcess = {
        update: function (element, valueAccessor) {
            const color = $.cdh.brandData.ChartContributionsVsIrsExcessColor;
            $(element).css('background', color);

            const pattern = $.cdh.helper.makeTagPattern(color, '2');
            const svg = $.cdh.helper.makePatternSvg(pattern);
            element.innerHTML += svg;
        }
    }
    ko.bindingHandlers.chartContributionsHSAvsIRSColorCatchUp = {
        update: function (element, valueAccessor) {
            const color = $.cdh.brandData.ChartContributionsVsIrsCatchUpColor;
            $(element).css('background', color);

            const pattern = $.cdh.helper.makeTagPattern(color, '0');
            const svg = $.cdh.helper.makePatternSvg(pattern);
            element.innerHTML += svg;
        }
    }
    ko.bindingHandlers.chartContributionsHSAvsIRSColorContributionLimit = {
        update: function (element, valueAccessor) {
            const color = $.cdh.brandData.ChartContributionsVsIrsContributionsLimitColor;
            $(element).css('background', color);

            const pattern = $.cdh.helper.makeTagPattern(color, '3');
            const svg = $.cdh.helper.makePatternSvg(pattern);
            element.innerHTML += svg;
        }
    }

    ko.bindingHandlers.chartContributionsHSAvsIRSColorHint = {
        update: function (element, valueAccessor) {
            var $el = $(element);
            $el.css('background', $.cdh.brandData.ChartContributionsVsIrsHintBackgroundColor);
            $el.css('color', $.cdh.brandData.ChartContributionsVsIrsHintTextColor);
            $el.find('.b-irs-limit-h').css('background-color', $.cdh.brandData.ChartContributionsVsIrsHintBackgroundColor);
        }
    }
})(jQuery, ko);